const columns = [
  { name: 'title', title: 'Titel' },
  { name: 'is_manager', title: 'Teamleiter' },
  { name: 'is_default', title: 'Standard' },
];

export default columns;
